import {Link} from 'react-router-dom';
import {Stack, Typography, MenuItem, Box} from '@mui/material';
import * as React from 'react';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const MenuItemsMobile = ({imageSrc, label, link}) => {
  const {mode} = useDarkMode();

  return (
    <MenuItem role="presentation">
      <Link
        to={`/${link}`}
        aria-label={'Aller à'}
        style={{
          textDecoration: 'none',
          display: 'inline-block',
          width: '100%',
        }}>
        <Stack direction={'row'} alignItems={'center'} gap={5}>
          <Box
            sx={{
              width: 45,
              height: 45,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <img src={imageSrc} alt={label} />
          </Box>
          <Typography
            variant={'subtitle5'}
            style={{color: mode.settings.textColor}}>
            {label}
          </Typography>
        </Stack>
      </Link>
    </MenuItem>
  );
};

export default MenuItemsMobile;
